import React from "react";
import useAutoResize from './useAutoResize';
import { Input } from 'reactstrap';

/**********************************************************************
 *  Tiny wrapper that your JSX uses
 *********************************************************************/
export default function AutoResizeInput({ value, onChange, onBlur, ...rest }) {
  const autoProps = useAutoResize(value);
  return (
    <Input
      type="textarea"
      value={value}
      onChange={onChange}
      onBlur={onBlur}
      {...autoProps}
      {...rest}
    />
  );
}